export default __webpack_public_path__ + "static/media/chains.8e100c55.png";